import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {EventResultsSearch} from '../eventResultsSearch/EventResultsSearch';
import {styles} from './styles';
import {DateTime} from '../shared/DateTime';
import {Social} from '../social/Social';
import MarkerIcon from 'react-icons/lib/ti/location-outline';
import {colors} from '../../shared/styles';

class EventDetailsComponent extends Component {
  static propTypes = {
    t: PropTypes.func
  };

  static defaultProps = {
    curatedMode: false,
    color: 'white'
  };

  state = {
    selectedYear: ''
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.master !== this.props.master) {
      this.setState({
        selectedYear: ''
      });
    }
  }

  getSearch() {
    if (this.props.isMobile || this.props.excludeSearch) {
      return null;
    }

    return (
      <div style={{position: 'relative'}}>
        <EventResultsSearch
          searchQuery={this.props.searchQuery}
          eventId={this.props.eventId}
          masterEventId={this.props.master.event.masterId}
        />
      </div>
    );
  }

  render() {
    const {
      master,
      color,
      curatedMode,
      isMobile,
      ctliveId,
      t
    } = this.props;

    //active event logo - TODO replace the placeholder image
    const imageUrl = (master || {}).imageUrl;

    let img;

    return (
      <div className="container">
        <div itemScope  itemType="http://schema.org/Event" >

          {
            // Image
          }
          <div
            className={curatedMode ? 'col-sm-10 col-lg-2' : ''}
            style={styles.logoContainer}
          >
            { imageUrl && ctliveId !== 0 &&
              <img
                ref={(i) => img = i}
                src={`${imageUrl}`}
                alt={''}
                style={styles.logo}
                onError={() => img.style.display = 'none'}/>
            }
          </div>

          {
            // Title
          }
          <div style={ curatedMode ? null : styles.nameColumn}>
            <h1
              id='master-event-name'
              style={ !curatedMode ? styles.name(isMobile) : {...styles.name(isMobile),  color: colors.black }}
              itemProp="name">
              {master.masterName}
            </h1>

            {this.props.type !== 'eventHeader' &&
              <div style={styles.mainTextStyle(color)}>
                {curatedMode ?
                  <div style={styles.eventDetailsDate} >

                    <span className="col-" itemProp="startDate" id='date-time'
                          style={styles.startDate}>
                      <DateTime
                        icon={null}
                        date={master.startEpoch * 1000}
                        showTime={false}/>
                    </span>

                    <span className="col-8"
                      itemProp="location"
                      itemScope itemType="http://schema.org/Place"
                      style={{paddingLeft: 0, paddingRight: 0}}
                      id='location'>
                      <span itemProp="address"
                        itemScope itemType="http://schema.org/PostalAddress">
                        <span itemProp="addressLocality">{master.city}</span>
                        <span>, </span>
                        <span itemProp="addressRegion">{master.region}</span>
                        <span>, </span>
                        <span itemProp="addressRegion">{master.country}</span>
                      </span>
                    </span>

                    <div style={{marginTop: 24}}>
                      <Social event={master} t={t} />
                    </div>

                    { isMobile &&
                      <div style={styles.loadMore}>
                        <Link to={`/event/${master.masterId}`}>
                          <span style={styles.register}>
                            {t('Learn More')}
                          </span>
                        </Link>
                      </div>
                    }
                  </div>

                  : // not curated mode

                  <div style={{clear: 'both'}}>
                    <span
                      className="col-"
                      itemProp="startDate"
                      style={styles.startDate}
                    >
                      <DateTime
                        date={master.startEpoch * 1000}
                        showTime={false}
                      />
                    </span>

                    <span className="col-8" itemProp="location" itemScope itemType="http://schema.org/Place"
                          style={styles.location}>
                      <span itemProp="address" itemScope itemType="http://schema.org/PostalAddress">
                        <MarkerIcon style={{paddingBottom: 3}}/>
                        {' '}
                        <span itemProp="addressLocality">{master.city}</span>
                        <span>, </span>
                        <span itemProp="addressRegion">{master.region}</span>
                        <span>, </span>
                        <span itemProp="addressRegion">{master.country}</span>
                      </span>
                    </span>
                  </div>
                }
              </div>
            }

          </div>
        </div>
        {this.getSearch()}
      </div>

    );
  }
}

export const EventDetails = withTranslation()(EventDetailsComponent);
